import localforage from 'localforage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { type SubscriptionInfo } from '../types';

interface SubscriptionStore {
    subscription: SubscriptionInfo | null;
    update: (data: SubscriptionInfo | null) => void;
    reset: VoidFunction;
}

export const useSubscriptionStore = create(
    persist<SubscriptionStore>(
        (set) => ({
            subscription: null,
            update: (data) => {
                set({ subscription: data });
            },
            reset: () => set({ subscription: null }),
        }),
        {
            name: 'subscription',
            storage: createJSONStorage(() => localforage),
        },
    ),
);
